import { useEffect, useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { api } from '../../api/client'
import type { Profile } from '../../lib/types'

/**
 * Поиск сотрудника с дебаунсом — общий кусок трёх пикеров (ManagerPicker,
 * TripMatesPicker, ApproverPicker), которые дублировали одну и ту же связку
 * useState+useEffect+useQuery. queryKey ['users', debounced] без scope не меняем —
 * это общий react-query кэш с остальными пикерами поиска людей.
 */
export function useUserSearch(scope?: 'all'): {
  q: string
  setQ: (v: string) => void
  /** отдебаунсенное значение — по нему решают «показывать ли дропдаун» */
  debounced: string
  hits: Profile[] | undefined
} {
  const [q, setQ] = useState('')
  const [debounced, setDebounced] = useState('')
  useEffect(() => {
    const t = setTimeout(() => setDebounced(q.trim()), 200)
    return () => clearTimeout(t)
  }, [q])

  const { data: hits } = useQuery({
    // scope в ключе: выдача юриста (весь холдинг) не должна попадать в кэш обычных пикеров.
    queryKey: scope ? ['users', debounced, scope] : ['users', debounced],
    queryFn: ({ signal }) => api.users(debounced, { signal, scope }),
    enabled: debounced.length >= 2,
  })

  return { q, setQ, debounced, hits }
}
